'use client'

import React, { ReactElement, ReactNode, useState } from 'react'
import { HotelData } from '@/types/Misc'
import { useTranslations } from 'next-intl'
import AngleDownIcon from '@/icons/font-awesome/sharp-light/angle-down.svg'

export function PopularFeaturesClientComponent(props: {
  popularFeatures: ReactNode
  hotel: HotelData
  featureBlocks: ReactNode
}): ReactElement {
  const [showAllPopularEquipment, setShowAllPopularEquipment] = useState(false)
  const t = useTranslations('Hotel.PopularFeatures')

  return (
    <>
      {Array.isArray(props.popularFeatures) && props.popularFeatures.length > 0 && (
        <>
          <div className="mb-8 border-b border-stone-200 pb-3"></div>
          <h2 className="pb-1 text-md font-semibold text-stone-900 sm:font-medium md:text-xl">
            {t('headline')}
          </h2>
          <div className="flex flex-row flex-wrap gap-x-3 gap-y-1 pb-2 text-sm lg:mb-3 lg:pb-0">
            {props.popularFeatures}
          </div>
          {!showAllPopularEquipment && (
            <button
              onClick={() => setShowAllPopularEquipment(true)}
              className="flex items-center text-sm text-stone-800 underline"
            >
              {t('showMore')} <AngleDownIcon className="ml-1 mt-1.5 h-3 w-3 fill-stone-800" />
            </button>
          )}
          <div className="mt-5">{showAllPopularEquipment && props.featureBlocks}</div>
        </>
      )}
    </>
  )
}
